// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { WebSocketProvider } from './stores/websocketContext';
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  //<React.StrictMode>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <WebSocketProvider
      remoteServerUrl={process.env.REACT_APP_SERVER_URL}
      jwtToken={process.env.REACT_APP_JWT}
    >
      <App />
    </WebSocketProvider>
  </GoogleOAuthProvider>
  //</React.StrictMode>
);
